module.exports = __webpack_public_path__ + "img/BQ.5f6ef944.svg";